const Home = () => {
  return (
    <section id="about">
      <div id='aboutText'>
      <h1>About Space Guardians</h1>
      <h2>How to play:</h2>
      <p>Use 'left' and 'right' to move, 'space' to shoot.<br/> Avoid getting shot by the extraterestrials and good luck!</p>
      <br/>
      Created by : The DareDevs
      </div>
    </section>
  );
};
export default Home
